import DeleteCustomer from '../../pages/Customer/DeleteCustomer';
import { CustomerController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const DeleteCustomerContainer = ({ closeModal, goBack }) => {
	const [loading, setLoading] = useState(false);

  const onDelete = async id => {
    setLoading(true);
    const {
      status,
      errorMessage,
    } = await CustomerController.deleteCustomer(id)

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    setLoading(false);
    return MimaToastUtil.error({
      message: errorMessage,
    });
  };

	return (
		<DeleteCustomer
			closeModal={closeModal}
			loading={loading}
      onDelete={onDelete}
			goBack={goBack}
		/>
	);
};

export default observer(DeleteCustomerContainer);